const storageMap = {
  common: {
    LANGUAGE: "avitsportfolio.language",
  },
  desktop: {
    SOUND_EFFECTS: "avitsportfolio.user-sound-effects",
    MUSIC: "avitsportfolio.user-sound-music",
  },
  mobile: {},
};

export default storageMap;
